
export const paginationCurrent = (pagination, deleteList) => {

    var len = pagination.total - deleteList
    if (len % pagination.pageSize == 0) {
        pagination.current = pagination.current - 1

        return pagination.current
    }
    else if (len == 0) {
        pagination.current = 1

        return pagination.current
    }
    else {
        return pagination.current
    }



}
export const showManagerUserPage = (companyType) => {
    if (companyType == 2 || companyType == 6) return true;
    else return false
}
export const getCategory = (val) => {
    val = val.replace('分析', '')
    if (val.indexOf('新品') > -1) return "新品速递"


    else return val
}

export const hilight_str = (key, strs) => {
    let idx = strs.indexOf(key), t = [];
    if (idx > -1) {
        if (idx == 0) {
            t = hilight_str(key, strs.substr(key.length))
            t.unshift({ key: true, str: key })
            return t;
        }
        if (idx > 0) {
            t = hilight_str(key, strs.substr(idx));
            t.unshift({ key: false, str: strs.substring(0, idx) });
            return t
        }
    }
    return [{ key: false, str: strs }];
}

export	const createTitle = (companyId, res,page) => {
			if (res) {
				res.map(item => {
					if(page=='catalog'){
                        item['total'] = 0
					if (item.children && item.children.length > 0) {
						item.children.map(ItemItem => {
                            ItemItem['titleList']=formatTitle(companyId,ItemItem.title)
							return ItemItem
						})
						item['total'] = item.children.length
					}
                    }
                    else{
                        item['titleList']=formatTitle(companyId,item.title)
                    }



					return item
				})
			}



			console.log(res, 'res')


			return res
}
export const  formatTitle=(companyId,title)=>{
    	var titleList = []
							//上海电气（可研）招标公告-威海热电2*66万千瓦热电联产项目配套热网优化升级改扩建工程可行性研究报告竞争磋商采购公告
							if (title.indexOf("（") == 0 && companyId == 782) {

								var index = title.indexOf('）')
								titleList.push(title.substring(0, index + 1))
								titleList.push(title.substring(index + 1, title.length))
								return titleList
							}
							else {
								return  [title]
							}
}